/**
 * Utility functions for generating and validating SEO-friendly event slugs on the frontend
 */

export function slugify(text) {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove all non-word chars except spaces and hyphens
    .replace(/[\s_]+/g, '-')   // Replace spaces and underscores with hyphens
    .replace(/--+/g, '-')      // Replace multiple hyphens with single hyphen
    .replace(/^-+/, '')        // Trim hyphens from start
    .replace(/-+$/, '');       // Trim hyphens from end
}

export function extractCity(location = '', address = '') {
  const combined = `${location} ${address}`.toLowerCase();
  
  if (combined.includes('seattle')) return 'seattle';
  if (combined.includes('bellevue')) return 'bellevue';
  if (combined.includes('redmond')) return 'redmond';
  if (combined.includes('kirkland')) return 'kirkland';
  if (combined.includes('sammamish')) return 'sammamish';
  if (combined.includes('renton')) return 'renton';
  if (combined.includes('tacoma')) return 'tacoma';
  if (combined.includes('olympia')) return 'olympia';
  if (combined.includes('spokane')) return 'spokane';
  if (combined.includes('bothell')) return 'bothell';
  
  return 'seattle';
}

export function extractYear(dateStr = '') {
  if (!dateStr) return new Date().getFullYear().toString();
  
  const dateObj = new Date(dateStr);
  if (!isNaN(dateObj.getTime())) {
    return dateObj.getFullYear().toString();
  }
  
  const match = dateStr.match(/\b(20\d{2})\b/);
  if (match) {
    return match[1];
  }
  
  return new Date().getFullYear().toString();
}

export function createEventSlug(event = {}) {
  if (!event || (!event.title && !event.id)) {
    return 'event';
  }
  
  if (event.slug && typeof event.slug === 'string' && event.slug.trim().length > 0) {
    return slugify(event.slug);
  }
  
  const titleSlug = slugify(event.title || 'cultural-event');
  const city = extractCity(event.location, event.address);
  const year = extractYear(event.date);
  
  let slugParts = [titleSlug];
  
  if (!titleSlug.includes(city)) {
    slugParts.push(city);
  }
  
  if (!titleSlug.includes(year)) {
    slugParts.push(year);
  }
  
  return slugParts.join('-');
}

export function getProductionBaseUrl() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    const origin = window.location.origin;
    if (!origin.includes('localhost') && !origin.includes('127.0.0.1')) {
      return origin;
    }
  }
  return process.env.REACT_APP_SITE_URL || 'https://beatsofwa.org';
}
